import {makeStyles} from "@material-ui/core";
import dayjs from '../../../services/customDayJs';
import {Colors} from "../../../styles/Colors";
import {GetAccountDashboardCallsPayload} from "../../../store/actions/accountDashboard/payloads";

export const useStyles = makeStyles(() => ({
    callEntry: {
        width: 'calc(100% - 32px)',
        padding: '11px 16px',
        flexDirection: 'row',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 34,

        '&:hover': {
            background: 'rgba(232, 250, 255, 1)',
            borderLeft: '4px solid rgba(81, 166, 237, 1)',
            paddingLeft: 12,
        }
    },
    playPauseButtonLoading: {
        color: Colors.Primary2,
        height: '28px !important',
        width: '28px !important',
        marginLeft: 8,
        marginRight: 8,

        '& .MuiCircularProgress-svg': {
            color: Colors.Primary2
        },
    },
    callEntryLeftItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    callEntryRightItem: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },
    callTimeContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: 4,
    },
    callDateLabel: {
        fontWeight: 400,
        fontSize: 12,
        textAlign: 'right',
        color: 'rgba(120, 144, 156, 1)',
        lineHeight: '12px',
        marginTop: 2
    },
    callTimeLabel: {
        fontWeight: 400,
        fontSize: 15,
        textAlign: 'right',
        color: Colors.Text,
        lineHeight: '15px',
    },
    callDetailsContainer: {
        width: 'fit-content',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginLeft: 12
    },
    caller: {
        fontWeight: 700,
        fontSize: 14,
        color: 'rgba(38, 50, 56, 1)',
        lineHeight: '16px'
    },
    callerExt: {
        fontWeight: 400,
        fontSize: 12,
        color: 'rgba(120, 144, 156, 1)',
        lineHeight: '14px',
    },
    secondLineContainer: {
        width: 'fit-content',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        lineHeight: '14px',
    },
    secondLineSeparator: {
        fontWeight: 700,
        fontSize: 12,
        marginLeft: 6,
        marginRight: 6,
        color: 'rgba(120, 144, 156, 1)',
        lineHeight: '14px',
    },
    durationText: {
        fontWeight: 700,
        fontSize: 12,
        color: 'rgba(120, 144, 156, 1)',
        lineHeight: '14px',
    },
    failedText: {
        fontWeight: 400,
        fontSize: 12,
        color: 'rgba(229, 57, 53, 1)',
        lineHeight: '14px',
    },
    activeCall: {
        background: 'rgba(255, 245, 221, 1)',
        borderLeft: '4px solid rgba(245, 132, 31, 1)',
        paddingLeft: 12,
    },
    callerAnimatedIcon: {
        width: 34,
        height: 34,
    },
    callDetailsContainerAnimated: {
        width: 190,
        userSelect: 'none'
    },
    noRecordingSpacer: {
        width: 44
    },
    audioPlayerRootContainer: {
        display: 'none !important'
    },
    actionButtonSpacer: {
        width: 4
    },
    primaryModalButton: {
        '& .MuiButton-label': {
            color: Colors.Primary,
        },
    },
    customWidgetContentClass: {
        height: 'fit-content',
        maxHeight: 'calc(100vh - 110px - 48px - 48px - 57px)'
    }
}));

export const formatDuration = (seconds: number, defaultValue = '0:00') => {
    if (!seconds) {
        return defaultValue;
    }
    const duration = dayjs.duration(seconds, 'seconds');
    let format = 'HH:mm:ss';

    if (seconds < 60) {
        format = '00:ss';
    } else if (seconds >= 60 && seconds < 3600) {
        format = 'mm:ss';
    }

    return duration.format(format);
};

const dateFormat = 'YYYY-MM-DD HH:mm:ss';
export const lastCallsPayloadInitial: GetAccountDashboardCallsPayload = {
    to_date: dayjs.utc().format(dateFormat),
    from_date: dayjs.utc().subtract(1, 'month').format(dateFormat),
    get_total: 1,
    i_service_type: 3,
    limit: 20,
    offset: 0,
    show_unsuccessful: 1,
    with_cr_download_ids: "1"
};